import React, { useState } from "react"

import { Link, navigate } from "gatsby"

function SubMenuNav({ link }) {
  const [openSub, setOpenSub] = useState(false)

  return (
    <div
      className={` overflow-hidden transition-all duration-300 ease-in ${
        openSub ? "max-h-[1000px]" : "max-h-12"
      }`}
      onClick={() => {
        if (!link.menu) {
          navigate(link.url)
        }
      }}
    >
      <div
        onClick={() => setOpenSub(!openSub)}
        activeClassName="text-[#3D41C2]"
        className=" flex gap-2 items-center"
      >
        <p className="text-[32px] font-[400] cursor-pointer">{link.text}</p>
        {link.menu && (
          <div className="w-[20px]">
            {openSub ? (
              <p></p>
            ) : (
              // <img className="w-full" src={chevron_up} alt="" />
              // <img className="w-full" src={chevron_down} alt="" />
              <p></p>
            )}
          </div>
        )}
      </div>
      {link.menu && (
        <div className="bg-[#ECECF9] p-4 w-full sm:w-[80%] rounded-md">
          {/* <p>{link.menu.title}</p> */}

          {/* {link.menu.links.map(link => (
            <Link
              to={link.url}
              activeClassName="text-[#3D41C2]"
              key={link.title}
              className="flex gap-2 items-center"
            >
              <div className="w-[60px] ">
                <img className="w-full" src={link.image} alt="" />
              </div>
              <p>{link.title}</p>
              <div>
                <img src={right_arrow_black} alt="" />
              </div>
            </Link>
          ))} */}
        </div>
      )}
    </div>
  )
}

export default SubMenuNav
